import styled from "styled-components";
import { FormSection, FormRow, FormField, FormLabel, FormInput, DocumentPreview } from "@/screen/Identities/Styles/IdentityFormStyles";

export { FormSection, FormRow, FormField, FormLabel, FormInput, DocumentPreview };

export const TallDocumentPreview = styled(DocumentPreview)`
    height: 480px;
`;